<template>
	<SuiActionBarToggleItem
		v-slot="{ closeDropdown }"
		name="filterSingleSelect"
		:label="label"
		:helper-label="helperLabel + ':'"
		class="filter-single-select"
	>
		<SuiSelectListButton
			v-for="option in options"
			:key="option.id"
			:active="filterValue === option.id"
			@click="onUpdateFilter(option.id, closeDropdown)"
		>
			{{ option.title }}
		</SuiSelectListButton>
	</SuiActionBarToggleItem>
</template>

<script setup lang="ts">
import {
	SuiActionBarToggleItem,
	SuiSelectListButton,
} from '@developers/scoro-ui';
import { toRefs, computed } from 'vue';

type FilterOption = {
	id: string;
	title: string;
};

type FilterSingleSelectProps = {
	modelValue: string;
	options: Array<FilterOption>;
	helperLabel: string;
};

const props = defineProps<FilterSingleSelectProps>();

const emit = defineEmits<{
	(e: 'update:model-value', id: string): void;
}>();

const { modelValue: filterValue, options } = toRefs(props);

const label = computed(
	() =>
		options.value.find(({ id }) => id === filterValue.value)?.title ||
		options.value[0].title
);

const onUpdateFilter = (id: string, closeDropdown: () => void) => {
	closeDropdown();

	emit('update:model-value', id);
};
</script>

<style lang="scss">
.filter-single-select {
	--sui-action-bar-toggle-item-z-index: #{z('modal')};
}
</style>
